import { render, staticRenderFns } from "./SecureNotify.vue?vue&type=template&id=420686b3&scoped=true"
import script from "./SecureNotify.vue?vue&type=script&lang=js"
export * from "./SecureNotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420686b3",
  null
  
)

export default component.exports